import { render, staticRenderFns } from "./ShopRegisterSet.vue?vue&type=template&id=6c754b2a&scoped=true&"
import script from "./ShopRegisterSet.vue?vue&type=script&lang=js&"
export * from "./ShopRegisterSet.vue?vue&type=script&lang=js&"
import style0 from "./ShopRegisterSet.vue?vue&type=style&index=0&id=6c754b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c754b2a",
  null
  
)

export default component.exports